import React, { useEffect } from "react";
import { Typography } from "@mui/material";
import { Link, useLocation, useHistory } from "react-router-dom";
import { ArrowBack, MailOutline } from "@mui/icons-material";
import { useTheme } from "@mui/styles";

import "./ForgotPasswordSuccessView.css";
import DashboardSnackbar from "../../../components/Snackbar.component";
import logoImage from "../../../assets/CRMAssets/psconnect_login_logo@2x.png";

function ForgotPasswordSuccessView() {
  const theme = useTheme();
  const history = useHistory();
  const location = useLocation();

  const email = location.state?.email || "";

  useEffect(() => {
    // Prevent opening this page directly without coming from Forgot Password
    if (!email) {
      history.replace("/forgot-password");
    }
  }, [email, history]);

  return (
    <div className="forgotPasswordSuccessPage">
      <div className="forgotPasswordSuccessOverlay"></div>

      <div className="forgotPasswordSuccessContainer">
        <div className="forgotPasswordSuccessCard">

          {/* Logo */}
          <div className="forgotPasswordSuccessLogoWrapper">
            <img
              src={logoImage}
              alt="PS Connect"
              className="forgotPasswordSuccessLogo"
            />
          </div>

          <div className="forgotPasswordSuccessContent">

            {/* Mail Icon */}
            <div className="forgotPasswordSuccessIconWrapper">
              <div className="forgotPasswordSuccessIcon">
                <MailOutline
                  style={{
                    fontSize: 45,
                    color: theme.palette.primary.main,
                  }}
                />
              </div>
            </div>

            {/* Heading */}
            <Typography className="forgotPasswordSuccessTitle">
              Check Your Email
            </Typography>

            {/* Description */}
            <Typography className="forgotPasswordSuccessDescription">
              A password reset link has been sent to
            </Typography>

            <Typography
              className="forgotPasswordSuccessEmail"
              style={{
                color: theme.palette.primary.main,
              }}
            >
              {email}
            </Typography>

            <Typography className="forgotPasswordSuccessInstruction">
              Click the link in the email to reset your password.
              <br />
              The link will expire in 1 hour.
            </Typography>

            {/* Info Box */}
            <div className="forgotPasswordSuccessInfoBox">
              <Typography variant="body2">
                <strong>Didn't receive it?</strong>{" "}
                <span className="forgotPasswordSuccessInfoText">
                  Check your spam folder or{" "}
                </span>

                <Link
                  to="/forgot-password"
                  className="forgotPasswordSuccessRetryLink"
                >
                  try a different email address.
                </Link>
              </Typography>
            </div>

            {/* Back Link */}
            <div className="forgotPasswordSuccessBackWrapper">
              <Link
                to="/forgot-password"
                className="forgotPasswordSuccessBackLink"
              >
                <ArrowBack
                  style={{
                    color: theme.palette.primary.main,
                    marginRight: 6,
                    fontSize: 20,
                  }}
                />

                <Typography
                  className="forgotPasswordSuccessBackText"
                  style={{
                    color: theme.palette.primary.main,
                  }}
                >
                  Back to Forgot Password
                </Typography>
              </Link>
            </div>

          </div>
        </div>

        <DashboardSnackbar />
      </div>
    </div>
  );
}

export default ForgotPasswordSuccessView;